import api from '@/api'
import constants from '../../helpers/constants'

let Q = require('q')

const state = {
  loading: false,

  refreshInterval: null,

  fetching: false
}

const getters = {
  loading: (state) => state.loading,

  fetching: (state) => state.fetching
}

const mutations = {
  SET_LOADING (state, isLoading) {
    state.loading = isLoading
  },

  SET_REFRESH_INTERVAL (state, func) {
    if (state.refreshInterval) {
      clearInterval(state.refreshInterval)
    }
    state.refreshInterval = setInterval(func, 25000)
  },

  SET_FETCHING (state, fetching) {
    state.fetching = fetching
  }
}

const actions = {
  init ({ commit, dispatch, rootGetters }) {
    // if (rootGetters['auth/accessToken']) {
    console.log('---INIT DATA---')
    commit('SET_LOADING', true)

    let promises = []

    // promises.push(dispatch('usuario/userLoggedIn', null, { root: true }))
    // promises.push(dispatch('map/fetchParamsComunidad', null, { root: true }))
    promises.push(dispatch('incendio/fetchAllIncendios', null, { root: true }))
    promises.push(dispatch('incendio/fetchIncendios', null, { root: true }))
    promises.push(dispatch('incendio/fetchTiposIncendioEstado', null, { root: true }))
    promises.push(dispatch('incendio/fetchTiposIncendioNivel', null, { root: true }))

    promises.push(dispatch('incendio/fetchTiposDeteccion', null, { root: true }))

    promises.push(dispatch('medio/fetchMedios', null, { root: true }))
    promises.push(dispatch('medio/fetchClasesMedio', null, { root: true }))
    promises.push(dispatch('medio/fetchCategoriasMedio', null, { root: true }))
    promises.push(dispatch('medio/fetchTiposMedio', null, { root: true }))
    promises.push(dispatch('medio/fetchZonasMedio', null, { root: true }))
    promises.push(dispatch('medio/fetchEmergencias', null, { root: true }))
    promises.push(dispatch('parametro/fetchParametros', null, { root: true }))
    promises.push(dispatch('medio/fetchEstadosMedio', null, { root: true }))
    promises.push(dispatch('equipo/fetchEquipos', null, { root: true }))
    promises.push(dispatch('equipo/fetchTiposEquipo', null, { root: true }))
    promises.push(dispatch('personalMedioTipo/fetchPersonalMedioTipo', null, { root: true }))
    promises.push(dispatch('medioPersonal/fetchMediosPersonales', null, { root: true }))

    promises.push(dispatch('infraestructura/fetchTipos', null, { root: true }))
    promises.push(dispatch('infraestructura/fetchInfraestructuras', null, { root: true }))
    promises.push(dispatch('estadosMedio/fetchEstadosMedio', null, { root: true }))
    promises.push(dispatch('infraestructura/fetchCategorias', null, { root: true }))
    promises.push(dispatch('infraestructura/fetchMunicipios', null, { root: true }))
    promises.push(dispatch('demarcacion/fetchDemarcaciones', null, { root: true }))
    promises.push(dispatch('infraestructura/fetchProvincias', null, { root: true }))
    promises.push(dispatch('infraestructura/fetchOrganismos', null, { root: true }))
    promises.push(dispatch('tituloProfesional/fetchTitulosProfesionales', null, { root: true }))
    promises.push(dispatch('organismo/fetchOrganismos', null, { root: true }))
    promises.push(dispatch('personalTipo/fetchTiposPersonal', null, { root: true }))
    promises.push(dispatch('personalCategoria/fetchCategoriasPersonal', null, { root: true }))

    promises.push(dispatch('personal/fetchPersonal', null, { root: true }))
    promises.push(dispatch('medioPersonal/fetchTurnos', null, { root: true }))

    promises.push(dispatch('emergencia/fetchEmergencias', null, { root: true }))
    promises.push(dispatch('emergencia/fetchEmergenciasTipo', null, { root: true }))
    promises.push(dispatch('emergencia/fetchEmergenciaEstadoTipo', null, { root: true }))
    promises.push(dispatch('usuario/fetchUsuarios', null, { root: true }))
    promises.push(dispatch('usuario/fetchRoles', null, { root: true }))

    Q.all(promises).then(() => {
      console.log('---LOADING DATA FINISHED---')

      this._vm.$socket.client.connect()
      dispatch('usuario/userLoggedIn', null, { root: true })

      // INIT INTERVAL REFRESH
      commit('SET_REFRESH_INTERVAL', () => {
        let pendingRequests = api.request.pendingRequests

        if (pendingRequests === 0) { // Solo lanzar el interval si no hay ninguna peticion en proceso
          commit('SET_FETCHING', true)
          // console.log('fetching...')
          let refreshingPromises = []

          refreshingPromises.push(dispatch('incendio/fetchAllIncendios', null, { root: true }))
          refreshingPromises.push(dispatch('incendio/fetchIncendios', null, { root: true }))
          refreshingPromises.push(dispatch('medio/fetchMedios', null, { root: true }))
          refreshingPromises.push(dispatch('parametro/fetchParametros', null, { root: true }))
          refreshingPromises.push(dispatch('personalMedioTipo/fetchPersonalMedioTipo', null, { root: true }))
          refreshingPromises.push(dispatch('personal/fetchPersonal', null, { root: true }))
          refreshingPromises.push(dispatch('emergencia/fetchEmergencias', null, { root: true }))
          refreshingPromises.push(dispatch('emergencia/fetchEmergenciasTipo', null, { root: true }))
          refreshingPromises.push(dispatch('emergencia/fetchEmergenciaEstadoTipo', null, { root: true }))
          refreshingPromises.push(dispatch('usuario/fetchUsuarios', null, { root: true }))

          Q.all(refreshingPromises).then(() => {
            // console.log('fetched')
            commit('SET_FETCHING', false)
          })
        }
      })
    }).catch((error) => {
      console.error(`Error init data ${error}`)
      this.notify('Error', 'Error al realizar la carga inicial de datos', 'error')
    }).finally(() => {
      commit('SET_LOADING', false)
    })
  },

  setLoading ({ commit }, isLoading) {
    commit('SET_LOADING', isLoading)
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
